import { Button, Icons, List, Table } from '@pankod/refine-antd'
import {
  IResourceComponentsProps,
  GetListResponse,
  LogicalFilter,
  CrudFilters,
  useNavigation,
  useRouterContext,
} from '@pankod/refine-core'
import Head from 'next/head'
import React from 'react'
import dayjs from 'dayjs'

import useTableWithMeta from 'src/hooks/useTableWithMeta'
import Filter, { TFilterForm } from '@components/ContentFilter'
import { TCommonError } from 'src/interfaces/common'
import { TLMSProgram } from '@resources/lms-management/program/types'

export const AlterProgramParticipantsList: React.FC<
  IResourceComponentsProps<GetListResponse<TLMSProgram>>
> = ({ options }) => {
  const { editUrl } = useNavigation()
  const { Link } = useRouterContext()

  const { tableProps, searchFormProps, filters } = useTableWithMeta<
    TLMSProgram,
    TCommonError,
    TFilterForm<{ name?: string }>
  >({
    dataProviderName: 'lms',
    resource: 'programs',
    initialSorter: [
      {
        field: 'endDate',
        order: 'desc',
      },
    ],
    onSearch(params) {
      const filters: CrudFilters = []
      const { name } = params
      const shouldAddTimestamp = [name].some(Boolean)
      filters.push(
        {
          field: 'name',
          operator: 'eq',
          value: name,
        },
        {
          field: 't',
          operator: 'eq',
          value: shouldAddTimestamp ? new Date().getTime() : undefined,
        },
      )
      return filters
    },
  })

  return (
    <List title="Daftar Program" canCreate={false}>
      <Head>
        <title>LMS Admin | {options?.label}</title>
      </Head>
      <Filter
        formProps={searchFormProps}
        filters={filters as LogicalFilter[]}
        layout="vertical"
        size="small"
        items={[
          {
            label: 'Nama Program',
            name: 'name',
          },
        ]}
      />
      <Table
        {...tableProps}
        scroll={{ x: 200 }}
        tableLayout="fixed"
        size="small"
        rowKey="id"
        columns={[
          { title: 'ID', dataIndex: 'id', width: 100 },
          { title: 'Nama Program', dataIndex: 'name', width: 200 },
          {
            title: 'Status',
            dataIndex: 'status',
            className: 'capitalize',
            width: 100,
          },
          {
            title: 'Periode',
            key: 'periode',
            width: 250,
            render: (_, record) => {
              return (
                <span className="grid gap-2 grid-cols-[100px_20px_100px]">
                  <span>{dayjs(record.startDate).format('DD MMM YYYY')}</span>
                  <span>&mdash;</span>
                  <span>{dayjs(record.endDate).format('DD MMM YYYY')}</span>
                </span>
              )
            },
          },
          {
            title: 'Aksi',
            width: 250,
            fixed: 'right',
            render: (_, record) => {
              return (
                <Link
                  to={editUrl('alter-program-participants', record.id)}
                  replace={false}
                >
                  <Button size="small" icon={<Icons.EditOutlined />}>
                    Kelola Program / Partisipan
                  </Button>
                </Link>
              )
            },
          },
        ]}
      />
    </List>
  )
}
